// 网站备案号页脚（2026-10-27 邢先生提供）
// ⚠️ 工信部要求：网站底部必须展示备案号，并链接到 beian.miit.gov.cn
// ⚠️ 网站备案号 = 鲁ICP备2026017674号-1
//    小程序备案号是「鲁ICP备2026017674号-3X」，两者不同，别搞混
import React from 'react';

export const ICP_NUMBER = '鲁ICP备2026017674号-1';
export const ICP_URL = 'https://beian.miit.gov.cn/';

/**
 * @param {boolean} light - 浅色背景用深灰字（主界面），深色背景用浅色字（登录页）
 */
export default function SiteFooter({ light = false }) {
  return (
    <div
      style={{
        textAlign: 'center',
        padding: '12px 8px',
        fontSize: 12,
        color: light ? '#999' : 'rgba(255,255,255,0.75)',
        lineHeight: 1.8,
        flex: '0 0 auto',
      }}
    >
      <a
        href={ICP_URL}
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: 'inherit', textDecoration: 'none' }}
        onMouseEnter={(e) => { e.currentTarget.style.textDecoration = 'underline'; }}
        onMouseLeave={(e) => { e.currentTarget.style.textDecoration = 'none'; }}
      >
        {ICP_NUMBER}
      </a>
      <span style={{ margin: '0 8px', opacity: 0.5 }}>|</span>
      <span>睿安车辆档案管理系统</span>
    </div>
  );
}
